import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { QrLinkComponent } from "../qr-link/qr-link.component";
import { firstValueFrom } from "rxjs";
import { ChipsComponent } from "../../modules/chips/chips.component";
import { TypeQrLink } from "../../enums/enums/typeQrLink.enum";
import { DialogsService } from "../../services/dialogs/dialogs.service";
import { BigButtonComponent } from "../big-button/big-button.component";

@Component({
  selector: "vl-qr-link-wrapper",
  standalone: true,
  imports: [ChipsComponent, BigButtonComponent],
  templateUrl: "./qr-link-wrapper.component.html",
  styleUrls: ["./qr-link-wrapper.component.scss"],
})
export class QrLinkWrapperComponent implements OnInit {
  @Input() type: TypeQrLink;
  @Input() lotId: string;
  @Input() controleId: string;
  @Input() ofId: string;
  @Input() opeId: string;
  @Input() forList: boolean = false;
  @Input() mode: "chips" | "big-button" = "chips";
  @Input() label: string;

  @Output() completed = new EventEmitter();

  hidden = true;

  constructor(private dialogsService: DialogsService) {}

  ngOnInit(): void {}

  async openQrCode() {
    const dialogRef = this.dialogsService.open(
      QrLinkComponent,
      "fit-content",
      "fit-content",
      {
        type: this.type,
        lotId: this.lotId,
        controleId: this.controleId,
        ofId: this.ofId,
        opeId: this.opeId,
        forList: this.forList,
      },
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      this.completed.emit(res?.body);
    }
  }
}
